<template>
  <div id="app">
    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<script>
import './scss/site.scss'
import { iframeParentCommunication } from './mixins/iframeParentCommunication'
import $ from 'jquery'
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'App',
  mixins: [iframeParentCommunication],
  computed: {
    ...mapGetters([
      'getLocale'
    ]),
    ...mapState({
      isPrimary: state => state.manageCampaigns.isPrimary
    })
  },
  created () {
    axios.get('../settings/load')
      .then(response => {
        this.$store.commit('SET_APP_CONFIG', response.data)
      })
      .catch(error => {
        console.log(error)
      })
    this.getCampaignDetails()
  },
  mounted () {
    if (this.$route.query.userEmail && this.getLocale === '') {
      const email = atob(this.$route.query.userEmail)
      this.$store.commit('SET_USER_EMAIL', email)
      this.$store.dispatch('setLocale', { email: email })
    }
    if (this.$store.getters.getCurrentClientId === 0) {
      // Standalone MCI component. Initialization will not start
      if (this.$route.query.clientId && this.$route.query.companyId) {
        this.$store.commit('SET_CLIENTID', this.$route.query.clientId)
        this.$store.commit('SET_COMPANYID', this.$route.query.companyId)
      }
      return
    }
    if (this.$route.query.userEmail) {
      const userEmail = atob(this.$route.query.userEmail)
      this.$store.dispatch('setUserAccessControl', { userEmail })
      this.$store.dispatch('setAccountId', { userEmail })
      this.$store.dispatch('setCompanySetting', {
        settings: 'IsInboxForecasterEnabled',
        email: userEmail
      })
    }

    // Attempt to inject the client override for local debugging
    // Don't set if the currentClientId was already set (>0)

    this.config = {
      height: () => document.body.clientHeight,
      width: () => '100%',
      mci_update_property_info: this.updatePropertyInfo,
      mci_set_parent_domain: this.setAppDomain,
      mci_route: this.routeRequest,
      mci_refresh_campaigns: this.refreshCampaigns
    }
    console.log('setAppDomain data: ', this.config)
    this.InitCommunication(this.config)
    const that = this
    this.onElementHeightChange(document.body, document.documentElement, function () {
      const data = { action: 'eIn_iframe_height_change', value: document.body.clientHeight }
      that.SendMessageToParent(data)
    })

    // Getting the parent eInsight application domain
    this.SendMessageToParent(
      { action: 'eIn_get_domain' }
    )

    // for debugging locally
    // this.$store.commit('SET_EINSIGHT_URI', 'qaeinsighteditor.cendyn.com')

    if (this.$route.query.clientId && this.$route.query.companyId) {
      this.init()
      this.$store.commit('SET_CLIENTID', this.$route.query.clientId)
      this.$store.commit('SET_COMPANYID', this.$route.query.companyId)
      if (this.$route.query.userEmail) {
        const email = atob(this.$route.query.userEmail)
        this.$store.commit('SET_USER_EMAIL', email)
      }
    } else {
      const waitingInitialization = setInterval(() => {
        console.log('waiting MCI initialization')
        if (window.InitializationWatcher.configLoaded) {
          this.init()
          clearInterval(waitingInitialization)
        }
      }, 500)
    }

    if (window.self !== window.top) {
      if (!document.body.className.includes('in-iframe')) {
        document.body.className += 'in-iframe'
      }
    }
  },
  methods: {
    onElementHeightChange (elm, html, callback) {
      let lastHeight = elm.clientHeight
      let newHeight = -1;
      (function run () {
        newHeight = Math.max(elm.clientHeight, elm.scrollHeight, elm.offsetHeight, html.offsetHeight)
        if (lastHeight !== newHeight) {
          callback()
        }

        lastHeight = newHeight

        if (elm.onElementHeightChangeTimer) {
          clearTimeout(elm.onElementHeightChangeTimer)
        }

        elm.onElementHeightChangeTimer = setTimeout(run, 100)
      })()
    },
    setAppDomain (data) {
      console.log('setAppDomain data: ', data)
      this.$store.commit('SET_EINSIGHT_URI', data.eInsightUri)
      window.InitializationWatcher.configLoaded = true
    },
    async getCampaignDetails () {
      const getURL = new URL(document.URL).href
      const wordToSearch = 'campaign-details'
      this.$router.push(
        {
          name:
            getURL.match(wordToSearch)
              ? 'CampaignDetails'
              : 'CampaignsAll',
          query: {
            clientId: this.$route.query.clientId,
            companyId: this.$route.query.companyId,
            campaignId: getURL.match(wordToSearch) ? this.$route.query.campaignId : ' ',
            userEmail: this.$route.query.userEmail
          }
        }
      )
    },
    // this is the method to handle the event from einsight
    // for changing the clientid and companyid when einsight
    // nav drop down changes
    updatePropertyInfo (propertyinfo) {
      if (!propertyinfo) {
        return
      }
      this.$store.commit('SET_CLIENTID', propertyinfo.clientid)
      this.$store.commit('SET_COMPANYID', propertyinfo.companyid)
      this.$store.commit('SET_ENV_NAME', propertyinfo.environmentName)
    },
    init () {
      this.SendMessageToParent(
        { action: 'eIn_iframe_init_done' }
      )

      // set up Click event listener on document to close parent eInsight menu dropdown if it's opened
      $(document).click(() => {
        this.SendMessageToParent(
          { action: 'eIn_Close_Menu_DropDown' }
        )
      })
    },
    routeRequest (data) {
      console.log('routeRequest: ', data)
      this.$router.push(data.hash)
    },
    refreshCampaigns () {
      if (this.$route.query.campaignId) {
        const campaignId = this.$route.query.campaignId
        const email = atob(this.$route.query.userEmail)
        setTimeout(function (scope) {
          if (campaignId) {
            scope.$store.dispatch('setCampaignSummary', { projectId: campaignId, userEmail: email })
            scope.$store.dispatch('setCampaignHistory', { projectId: campaignId, userEmail: email })
          }
        }, 1000, this)
      } else {
        this.$store.dispatch('setCampaignsByPage', {
          companyId: this.$route.query.companyId,
          isPrimary: this.isPrimary,
          userEmail: atob(this.$route.query.userEmail)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap4.css";

  #app {
    padding: 0 9px 0;
    overflow: hidden;
    width: 100%;
    min-height: 600px;
  }

  .e-toast-container {
    .e-toast {
      &.notification-error {
        color: $danger !important;
        border-color: rgba(168,40,35,.5) !important;
        background-color: #faeae9 !important;
      }
      &.notification-info {
        color: $info !important;
        border-color: $info-dark !important;
        background-color: $info-light !important;
      }
      color: $success !important;
      border-color:rgba(101,141,48,.5) !important;
      background-color: #f8fbf4 !important;
    }
  }
  #dialog-schedule {
    max-height: none !important;
  }
</style>
